import { isArrayLike, selector } from '@poa/state';
import { calculateSumByHeaderId } from '../../components/data-table/data-table-helpers';

function getTableTotal(tbody) {
  return calculateSumByHeaderId(tbody, 'total');
}

function getTableTotalText(tbody) {
  const total = getTableTotal(tbody);

  return `($: ${`${total}`.split('.')[0]})`;
}

export const makeGetTableGroupedSelector = moduleName =>
  selector(store => {
    const selectedGroupingColumn = store[moduleName].filters.grouping.selected.value;
    let data = store[moduleName].data;

    // do not grouping anything
    if (selectedGroupingColumn === 'none' || selectedGroupingColumn === 'default') {
      switch (moduleName) {
        case 'reports':
          return data.map(table => ({
            ...table,
            title: `${table.title || store.reports.filters.startDate.format('MMMM')}`,
            groupedTotal: getTableTotalText(table.tbody)
          }));
        default:
          return data;
      }
    }

    const rowsMap = new Map();
    let tableName;

    data = [];

    store[moduleName].data.forEach(table => {
      Object.values(table.thead).forEach(headers => {
        headers.forEach(header => {
          if (header.name === selectedGroupingColumn) {
            tableName = header.verbose_name;
          }
        });
      });

      table.tbody.forEach(row => {
        const sections = Object.keys(row);

        for (let i = 0, l = sections.length; i < l; i++) {
          const sectionId = sections[i];

          if (!row[sectionId]) {
            continue;
          }

          const sectionData = row[sectionId][selectedGroupingColumn];

          // ignore id, status keys
          if (sectionId === 'id' || sectionId === 'status') {
            continue;
          }

          if (!sectionData) {
            continue;
          }

          if (typeof sectionData !== 'object') {
            continue;
          }

          const key = isArrayLike(sectionData.value) ? sectionData.value[0] : sectionData.value;

          if (rowsMap.has(key)) {
            rowsMap.get(key).push(row);
          } else {
            rowsMap.set(key, [row]);
          }
        }
      });
    });

    let keys;

    switch (selectedGroupingColumn) {
      case 'operator':
        keys = Array.from(rowsMap.keys())
          .map(key => ({ key, total: getTableTotal(rowsMap.get(key)) }))
          .sort((a, b) => b.total - a.total)
          .map(item => item.key);
        break;
      default:
        keys = Array.from(rowsMap.keys()).sort((a, b) => {
          const aNumber = parseInt(a, 10);
          const bNumber = parseInt(b, 10);

          if (typeof a === 'string' && isNaN(aNumber) && isNaN(bNumber)) {
            return a.localeCompare(b);
          }

          return aNumber > bNumber ? 1 : aNumber < bNumber ? -1 : 0;
        });
        break;
    }

    keys.forEach(key => {
      switch (moduleName) {
        case 'reports':
          data.push({
            // just use reference of original header & footer
            thead: store[moduleName].data[0].thead,
            tfoot: store[moduleName].data[0].tfoot,
            tbody: rowsMap.get(key),
            title: `${tableName}: ${key}`,
            groupedTotal: getTableTotalText(rowsMap.get(key))
          });
          break;
        default:
          data.push({
            // just use reference of original header & footer
            thead: store[moduleName].data[0].thead,
            tfoot: store[moduleName].data[0].tfoot,
            tbody: rowsMap.get(key),
            title: `${tableName}: ${key}`
          });
          break;
      }
    });

    return data;
  });
